"use client";

import { useEffect } from "react";
import { initFlare } from "@/lib/flare";

/**
 * Starts browser error reporting.
 *
 * Deliberately NOT gated on a hardcoded hostname list, unlike PostHogProvider.
 * The apex has not been cut over yet - the deploy workflow runs DEPLOY_ENV
 * preview and serves new.trein-vertraging.nl - so a hostname allowlist would
 * silently disable reporting on the site that is actually live, which is the
 * exact failure this whole change exists to prevent.
 *
 * Instead the key itself is the switch: reporting happens wherever
 * NEXT_PUBLIC_FLARE_KEY is injected at build time, and NEXT_PUBLIC_APP_STAGE
 * labels which deploy a report came from so preview and production stay
 * separable inside Flare rather than being dropped on the floor.
 *
 * Not gated on analytics consent: this carries no identifiers and no
 * behavioural data - the site is anonymous and initFlare never calls setUser -
 * so it is operational diagnostics rather than analytics. If identity is ever
 * attached, it must move behind the consent gate in lib/consent.
 */
export default function FlareInit() {
  useEffect(() => {
    initFlare(process.env.NEXT_PUBLIC_FLARE_KEY, {
      stage: process.env.NEXT_PUBLIC_APP_STAGE ?? "production",
      release: process.env.NEXT_PUBLIC_APP_RELEASE,
    });
  }, []);

  return null;
}
